import sal from 'sal.js';

const scrollAnimation = {
    init: () => {
        sal({
            threshold: 0.1
        });
    }
};

scrollAnimation.init();